'use strict';

const $ = jQuery.noConflict();
$(function() {

	const banner = {

		init: function() {
			this.bannerPopup();
		},

		// bannerPopup: function() {
		// 	const $modal = $('.js-video-modal');
		// 	const $iframe = $modal.find('iframe');

		// 	$('.js-open-video').on('click', function() {
		// 		$modal.addClass('is-active');
		// 		$('body').css('overflow', 'hidden');

		// 		const src = $iframe.attr('src');
		// 		if (src && !src.includes('autoplay=1')) {
		// 			$iframe.attr('src', src + (src.includes('?') ? '&' : '?') + 'autoplay=1');
		// 		}
		// 	});

		// 	$('.js-close-video').on('click', function() {
		// 		$modal.removeClass('is-active');
		// 		$('body').css('overflow', '');

		// 		// reset iframe → stop video
		// 		const src = $iframe.attr('src');
		// 		if (src) {
		// 			$iframe.attr('src', src.replace('&autoplay=1', '').replace('?autoplay=1', ''));
		// 		}
		// 	});
		// },
		bannerPopup: function() {
			const $modal = $('.js-video-modal');
			const $iframe = $modal.find('iframe');
			const $bgVideo = $('.hero-video__bg');

			$('.js-open-video').on('click', function() {
				$modal.addClass('is-active');
				$('body').css('overflow', 'hidden');

				// PAUZA background videa
				if ($bgVideo.length) {
					$bgVideo[0].pause();
				}

				const src = $iframe.attr('src');
				if (src && !src.includes('autoplay=1')) {
					$iframe.attr('src', src + (src.includes('?') ? '&' : '?') + 'autoplay=1');
				}
			});

			$('.js-close-video').on('click', function() {
				$modal.removeClass('is-active');
				$('body').css('overflow', '');

				// NASTAVI background video
				if ($bgVideo.length) {
					$bgVideo[0].play();
				}

				// reset iframe → stop video
				const src = $iframe.attr('src');
				if (src) {
					$iframe.attr('src', src.replace('&autoplay=1', '').replace('?autoplay=1', ''));
				}
			});
		},
	};

	banner.init();
});
